import * as contentfulClient from 'app/api/contentful-client';
import * as actions from 'app/store/actions/glowforge-store';

export const fetchGlowforgeOrderPageLite = () => ({
  promise: () => contentfulClient.getPage('glowforge-order-page'),
  events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_ORDER_CONTENTFUL_PAGE, 'PROMISE_ERROR'],
});

export const fetchProducts = () => ({
  promise: async http => (http.get('/base://storefront/api/search')),
  events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_PRODUCT_LIST, 'PROMISE_ERROR'],
});

export const fetchComparisonData = () => ({
  promise: () => contentfulClient.getGlowforgeComparisonChart(),
  events: ['PROMISE_PENDING', actions.SET_COMPARISON_DATA, 'PROMISE_ERROR'],
});

export const fetchOrderDetails = (orderNumber, key) => ({
  promise: async http => (http.get(`/base://storefront/api/orders/details?number=${orderNumber}&key=${key}`)),
  events: ['PROMISE_PENDING', actions.SET_ORDER_DETAILS, 'PROMISE_ERROR'],
});

export const fetchConfirmationPage = () => ({
  promise: () => contentfulClient.getPage('glowforge-confirmation-page'),
  events: ['PROMISE_PENDING', actions.SET_CONFIRMATION_PAGE, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/store/api/glowforge-store-api.js